import { render, staticRenderFns } from "./ed-disclamer.vue?vue&type=template&id=3d39734a&scoped=true&"
import script from "./ed-disclamer.ts?vue&type=script&lang=js&"
export * from "./ed-disclamer.ts?vue&type=script&lang=js&"
import style0 from "./ed-disclamer.scss?vue&type=style&index=0&id=3d39734a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d39734a",
  null
  
)

export default component.exports